import axios from 'axios'
import { currentLanguage } from '@/app/i18n'
import { api } from '@/shared/api/client'

export function filenameFromDisposition(header: unknown, fallback: string): string {
  const raw = typeof header === 'string' ? header : ''
  const encoded = /filename\*=\s*UTF-8''([^;]+)/i.exec(raw)?.[1]
  if (encoded) {
    try {
      return decodeURIComponent(encoded.trim())
    } catch {
      return fallback
    }
  }
  return /filename=\s*"?([^";]+)"?/i.exec(raw)?.[1]?.trim() ?? fallback
}

function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

// `blob` so'rovida xato konverti ham Blob bo'lib keladi — teg tarjima qilinishi uchun JSON ga qaytariladi.
async function withJsonBody(error: unknown): Promise<unknown> {
  if (!axios.isAxiosError(error) || !(error.response?.data instanceof Blob)) return error
  try {
    error.response.data = JSON.parse(await error.response.data.text()) as unknown
  } catch {
    return error
  }
  return error
}

export async function downloadFile(
  path: string,
  params: Record<string, string>,
  fallbackName: string,
): Promise<void> {
  try {
    const response = await api.get<Blob>(path, {
      params,
      responseType: 'blob',
      timeout: 0,
      headers: { 'Accept-Language': currentLanguage() },
    })
    saveBlob(response.data, filenameFromDisposition(response.headers['content-disposition'], fallbackName))
  } catch (error) {
    throw await withJsonBody(error)
  }
}
